import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "../context/AppContext";

export default function Auth() {
  const { t, lang, login, register } = useApp();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "", confirm: "" });
  const navigate = useNavigate();

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (mode === "login") {
      const r = await login({ email: form.email, password: form.password });
      if (r.ok) { toast.success(t("welcome")); navigate("/account"); }
      else toast.error(r.error || (lang === "tr" ? "E-posta veya şifre hatalı." : "Invalid email or password."));
    } else {
      if (form.password !== form.confirm) return toast.error(lang === "tr" ? "Şifreler eşleşmiyor." : "Passwords do not match.");
      const r = await register({ name: form.name, email: form.email, password: form.password });
      if (r.ok) { toast.success(t("welcome")); navigate("/account"); }
      else toast.error(r.error || (lang === "tr" ? "Bu e-posta zaten kayıtlı." : "This email is already registered."));
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16 bg-neutral-50">
      <div className="w-full max-w-md bg-white border border-neutral-200 p-8 md:p-10">
        <h1 className="brand-font text-3xl tracking-wide text-center mb-2">{mode === "login" ? t("signInTitle") : t("registerTitle")}</h1>
        <div className="w-10 h-[2px] mx-auto mb-8" style={{ backgroundColor: "var(--brand)" }} />

        <form onSubmit={submit} className="space-y-4">
          {mode === "register" && (
            <Field label={t("name")} value={form.name} onChange={upd("name")} required />
          )}
          <Field label={t("email")} type="email" value={form.email} onChange={upd("email")} required />
          <Field label={t("password")} type="password" value={form.password} onChange={upd("password")} required />
          {mode === "register" && (
            <Field label={t("confirmPassword")} type="password" value={form.confirm} onChange={upd("confirm")} required />
          )}
          <button type="submit" className="w-full py-3.5 text-white text-xs tracking-[0.2em] uppercase transition-opacity hover:opacity-90" style={{ backgroundColor: "var(--brand)" }}>
            {mode === "login" ? t("login") : t("register")}
          </button>
        </form>

        <div className="text-center mt-6 text-sm text-neutral-500">
          {mode === "login" ? t("noAccount") : t("haveAccount")}{" "}
          <button onClick={() => setMode(mode === "login" ? "register" : "login")} className="font-medium" style={{ color: "var(--brand)" }}>
            {mode === "login" ? t("register") : t("login")}
          </button>
        </div>
      </div>
    </div>
  );
}

function Field({ label, ...props }) {
  return (
    <div>
      <label className="block text-[11px] tracking-widest uppercase text-neutral-500 mb-2">{label}</label>
      <input {...props} className="w-full border border-neutral-300 px-4 py-3 text-sm outline-none focus:border-neutral-900 transition-colors" />
    </div>
  );
}
